import moment from 'moment';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ModalContext from '@src/context';
import featureNames from '@utils/featureToggle/constants';

import { FilterDropdown } from '..';
import MemoDatePicker from './DatePickers';
import styles from './index.less';

//  being imported at multiple places
class SummaryContainer extends PureComponent<any> {
  static contextType = ModalContext;
  private summaryDatePickerRef: any;
  private comparisonDatePickerRef: any;

  constructor(props) {
    super(props);
    this.summaryDatePickerRef = React.createRef();
    this.comparisonDatePickerRef = React.createRef();
    this.state = {};
  }

  hasIntervalChanged = (newInterval) => {
    const { interval } = this.props;
    try {
      if (
        newInterval[0].isSame(moment(interval?.from)) &&
        newInterval[1].isSame(moment(interval?.to))
      ) {
        return false;
      }
    } catch (err) {
      // pass
      // falls back to current behaviour
    }
    return true;
  };

  validateUpdateInterval = (dates, short) => {
    const { updateInterval: updateIntervalAction } = this.props;
    // check if summary interval changed before triggering redux action
    // as there are multiple listeners
    if (this.hasIntervalChanged(dates)) {
      updateIntervalAction(dates[0].format(), dates[1].format(), short);
    }
  };

  render() {
    const { interval, features, calenderBoundry } = this.props;
    const durationAllowed = features[featureNames.DATA_ACCESS_DURATION];
    const durationLimit = 14;
    return (
      <div className={styles.empSummaryContainer}>
        <div className={styles.empTopWrapper}>
          <FilterDropdown>{this.props.children}</FilterDropdown>
          <MemoDatePicker
            key={`${JSON.stringify(interval)}`}
            interval={interval}
            comparisonInterval={{ from: '', to: '', shortcut: '' }}
            setComparisonUnavailable={() => {}}
            setComparisonInterval={() => {}}
            dod={false}
            summaryDatePickerRef={this.summaryDatePickerRef}
            validateUpdateInterval={this.validateUpdateInterval}
            comparisonDatePickerRef={this.comparisonDatePickerRef}
            durationAllowed={durationAllowed}
            durationLimit={durationLimit}
            calenderBoundry={calenderBoundry}
          />
        </div>
      </div>
    );
  }
}

export default connect(null, {})(SummaryContainer);
